import { User } from '@/store/user/types';
import apiRequest from '@/utils/apiRequest';
import { RequestUserData } from '@/utils/apiRequest/types';
import { calmLogger } from '@/utils/calmLogger';

export async function getUser(userData: RequestUserData): Promise<User | null> {
	if (!userData.userToken) return null;
	try {
		const result = await apiRequest({
			endpoint: 'v2/me',
			method: 'GET',
			userData,
		});

		return result?.data || null;
	} catch (err) {
		calmLogger.error('Error retrieving user via GET /me', {}, err);
		return null;
	}
}
